import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MdNotifications } from 'react-icons/md';
import Lottie from 'react-lottie';
import { useMediaQuery } from 'react-responsive';

import { Wrapper, Notification, Modal } from './styles';
import Sider from '~/components/Sider';
import emptynotify from '~/assets/animations/emptynotify.json';

export default function DefaultLayout({ children }) {
  const [modal, setModal] = useState(false);

  const isMobile = useMediaQuery({
    query: '(max-width: 500px)',
  });

  function toggleModal() {
    return modal === false ? setModal(true) : setModal(false);
  }

  return (
    <Wrapper>
      {isMobile ? null : <Sider />}
      {isMobile ? null : (
        <Notification hasUnread={false} className="notifications">
          <MdNotifications size={30} color="#fff" onClick={toggleModal} />

          {modal === true ? (
            <Modal>
              <p style={{ marginTop: 30 }}>
                Você nāo possui nenhuma notificaçāo no momento.
              </p>
              <Lottie
                options={{
                  loop: false,
                  autoplay: true,
                  animationData: emptynotify,
                }}
                height={250}
                width={250}
                style={{ marginTop: -30, marginLeft: -40 }}
              />
            </Modal>
          ) : null}
        </Notification>
      )}

      <div
        style={{
          paddingLeft: 100,
        }}
      >
        {children}
      </div>
    </Wrapper>
  );
}

DefaultLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
